import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { SurveyCreationAudienceEffects } from './state/audience/survey-creation-audience.effects';
import { SurveyCreationAdvancedFiltersEffects } from './state/insights/survey-creation-advanced-filters.effects';
import { SurveyCreationInsightsEffects } from './state/insights/survey-creation-insights.effects';
import { SurveyCreationReferenceEffects } from './state/reference/survey-creation-reference.effects';
import { surveyCreationFeature } from './state/survey-creation.feature';

export const SURVEY_CREATION_STORE_PROVIDERS = {
  feature: provideState(surveyCreationFeature),
  effects: provideEffects(
    SurveyCreationAudienceEffects,
    SurveyCreationInsightsEffects,
    SurveyCreationAdvancedFiltersEffects,
    SurveyCreationReferenceEffects,
  ),
};
